/**
 * Desplegable de Áreas del chat del Brain (People, Finance). La lista la decide
 * el backend (`brain.listAreas`): People para cualquier clapper, Finance solo
 * para quien esté en la governance de Control Presupuestario.
 */

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { BRAIN_AREA_PREFIX, BRAIN_AREAS } from '../../../../shared/types/brain';

interface AreaSelectorProps {
  /** Scope completo (`area:people`) o null si hay un cliente elegido. */
  value: string | null;
  onChange: (v: string) => void;
  disabled?: boolean;
}

export function AreaSelector({ value, onChange, disabled }: AreaSelectorProps) {
  const { data, isLoading } = trpc.brain.listAreas.useQuery(undefined, { staleTime: 60_000, retry: false });
  const { t } = useTranslation();
  const areas = data?.areas ?? [];

  return (
    <Select value={value ?? ''} onValueChange={onChange} disabled={disabled || isLoading || areas.length === 0}>
      <SelectTrigger className="w-36 h-9 text-sm" aria-label={t('brain.selector.areas_label')}>
        <SelectValue placeholder={isLoading ? t('brain.selector.loading') : t('brain.selector.areas_placeholder')} />
      </SelectTrigger>
      <SelectContent>
        {areas.map((id) => (
          <SelectItem key={id} value={`${BRAIN_AREA_PREFIX}${id}`}>
            {BRAIN_AREAS[id] ?? id}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
